export type FirestoreEmulatorEnvironmentConfig = Record<string, never>;
